import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BookModalSectionComponent } from './book-modal-section.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [BookModalSectionComponent],
  imports: [CommonModule, TranslateModule],
  exports: [BookModalSectionComponent],
})
export class BookModalSectionModule {}
